import Script from "next/script";
import "../styles/index.css";
import "../styles/style.scss";

function MyApp({ Component, pageProps }) {
  return (
    <>
      {/* <Script
        src="https://www.googletagmanager.com/gtag/js?id=GTM-TKSM6D7"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'GTM-TKSM6D7');
        `}
      </Script> */}

      <Script src="https://www.googletagmanager.com/gtag/js?id=G-3VEPCL9J86" strategy="afterInteractive"/>
      <Script id="google-analytics" strategy="afterInteractive">      
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-3VEPCL9J86');
        `}
      </Script>

      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
